export const MEMBER_PORTAL_COLLECTION = 'member-portal';
export const MEMBER_PORTAL_COLLECTION_V53 = 'member-portal-v53';
export const MEMBER_PORTAL_OTP_COLLECTION = 'member-portal-otp';
export const MEMBER_PORTAL_APAC_COLLECTION = 'member-portal-apac';
export const EDITABLE_HIDDEN_PRODUCTS = 'editable-hidden-products';
export const MEMBER_PORTAL_V53 = 'member-portal-v53';
export const UPSELL_SUBSCRIPTION_PRODUCTS = 'upsell-subscription-products';
export const MEMBER_PORTAL_WELCOME_KIT_COLLECTION = 'welcome-kit-v53';
export const ANZ_COLLECTION = 'anz';
// EU locale split
export const EU_EN_COLLECTION = 'ag1-en';
export const EU_DE_COLLECTION = 'ag1-de';
export const TEMPORARY_MIGRATION_PHONE_NUMBERS: Record<string, string> = {
  us: '8888888888', // US
  au: '488888888', // Australia
  gb: '3388888888', // UK
  sg: '8008888888', // Singapore
  tw: '988888888', // Taiwan
  hk: '98988888', // Hong Kong
  de: '491234567890', // Germany
  be: '32470123456', // Belgium
  at: '436641234567', // Austria
  li: '4232345678', // Liechtenstein
  hr: '385911234567', // Croatia
  hu: '36301234567', // Hungary
  lt: '37061234567', // Lithuania
  pl: '48512345678', // Poland
  it: '393451234567', // Italy
  dk: '4542123456', // Denmark
  si: '38631123456', // Slovenia
  fi: '358401234567', // Finland
  bg: '359871234567', // Bulgaria
  cy: '35799123456', // Cyprus
  ch: '41781234567', // Switzerland
  ro: '40712345678', // Romania
  gr: '306971234567', // Greece
  cz: '420601123456', // Czech Republic
  no: '4741234567', // Norway
  ee: '37251234567', // Estonia
  nl: '31612345678', // Netherlands
  lu: '352621123456', // Luxembourg
  pt: '351912345678', // Portugal
  mc: '377612345678', // Monaco
  mt: '35699123456', // Malta
  sk: '421903123456', // Slovakia
  ie: '353851234567', // Ireland
  es: '34612345678', // Spain
  fr: '33612345678', // France
  se: '46701234567' // Sweden
};
